/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CivMapAction } from '../model/civMapAction';
import { CivMapSquaresAction } from '../model/civMapSquaresAction';
import { CivUuidAction } from '../model/civUuidAction';
import { GameEngineDto } from '../model/gameEngineDto';
import { MapTerrainAction } from '../model/mapTerrainAction';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineStartOfTurnService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Place capital
     * Place capital to the map
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeCapital(body: CivMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeCapital(body: CivMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeCapital(body: CivMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeCapital(body: CivMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeCapital.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeCapital.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/start-of-turn/place-capital`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Place city
     * Place city to the map
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public placeCity(body: CivMapAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public placeCity(body: CivMapAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public placeCity(body: CivMapAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public placeCity(body: CivMapAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling placeCity.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling placeCity.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/start-of-turn/place-city`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set government
     * Set civilization government
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setGovernment(body: CivUuidAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public setGovernment(body: CivUuidAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public setGovernment(body: CivUuidAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public setGovernment(body: CivUuidAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setGovernment.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling setGovernment.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/start-of-turn/set-government`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set terrain
     * Set map square terrain
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setTerrain(body: MapTerrainAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public setTerrain(body: MapTerrainAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public setTerrain(body: MapTerrainAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public setTerrain(body: MapTerrainAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setTerrain.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling setTerrain.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/start-of-turn/set-terrain`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Swap positionables
     * Swap positionables between to squares
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public swapPositionables(body: CivMapSquaresAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public swapPositionables(body: CivMapSquaresAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public swapPositionables(body: CivMapSquaresAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public swapPositionables(body: CivMapSquaresAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling swapPositionables.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling swapPositionables.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/start-of-turn/swap-positionables`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
